import { Controller } from "@hotwired/stimulus"

// Beschränkt die Eingabe auf Ziffern (z. B. für PLZ) durch Blockieren nicht erlaubter Tasten bei keydown.
// Verwendung: data-controller="numeric-input" auf Wrapper, data-numeric-input-target="input" am Input
// Optional: data-numeric-input-max-length-value="5"
export default class extends Controller {
  static targets = ["input"]
  static values = { maxLength: { type: Number, default: 0 } }

  connect() {
    this.boundKeydown = this.keydown.bind(this)
    const el = this.hasInputTarget ? this.inputTarget : this.element
    el.addEventListener("keydown", this.boundKeydown, true)
  }

  disconnect() {
    const el = this.hasInputTarget ? this.inputTarget : this.element
    el.removeEventListener("keydown", this.boundKeydown, true)
  }

  keydown(event) {
    const el = this.hasInputTarget ? this.inputTarget : this.element
    const key = event.key
    if (/^\d$/.test(key)) {
      const max = this.maxLengthValue
      if (max > 0) {
        const start = el.selectionStart
        const end = el.selectionEnd
        const len = el.value.length - (end - start) + 1
        if (len > max) event.preventDefault()
      }
      return
    }
    const allowed = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"]
    if (allowed.includes(key)) return
    if (event.ctrlKey || event.metaKey) {
      if (["a", "c", "v", "x"].includes(key.toLowerCase())) return
    }
    event.preventDefault()
  }
}
